import { render, staticRenderFns } from "./GlobalSnackbar.vue?vue&type=template&id=1503d732&scoped=true&lang=pug"
import script from "./GlobalSnackbar.vue?vue&type=script&lang=ts"
export * from "./GlobalSnackbar.vue?vue&type=script&lang=ts"
import style0 from "./GlobalSnackbar.vue?vue&type=style&index=0&id=1503d732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503d732",
  null
  
)

export default component.exports